
export enum Constants {
    TEST = "TEST",
    
    TaskInfos = "TaskInfos",
    DailyTasksInfos = "DailyTasksInfos",
    GoodsList = "GoodsList",
    VipInfos = "VipInfos",
    VipDailyCash = "VipDailyCash",
    VipEquityList = "VipEquityList",
}